export default __webpack_public_path__ + "static/media/movietheatresbg.dd70e996.png";